import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <div>Ballin</div>
    </div>
  );
}

export default App;
